import React from "react";
import { Section, SectionHeading } from "./Section";
import { CheckList } from "./CheckList";
import { OfferCard } from "./OfferCard";
import { finalIncludes } from "../data/offer";
export function FinalCTA() {
  return <Section tone="dark" data-id="element-121" data-mp="c7k3psj52dm8">
      <SectionHeading tone="dark" eyebrow="Ready to organize your clinical references?" title="Bring Your Facial Aesthetic Educational Resources Together in One Place." intro={["You’ve invested time in developing your professional knowledge.", "Now you can organize related educational references, assessment worksheets, case studies, and documentation resources within a single collection."]} data-id="element-122" data-mp="c4o665b7dqyb" />
      <div className="mx-auto mt-10 max-w-2xl rounded-3xl bg-navy-800 p-6 md:p-8" data-id="element-123" data-mp="qwq59n5g8fxa">
        <p className="mb-5 text-xs font-bold uppercase tracking-[0.16em] text-gold-300" data-id="element-124" data-mp="14uog4ikk9u81">
          Your complete Facial Aesthetics Clinical Roadmap™ includes:
        </p>
        <CheckList items={finalIncludes} tone="dark" columns data-id="element-125" data-mp="2c4ob8wnbx767" />
      </div>
      <div className="mt-10" data-id="element-126" data-mp="2c6r9g3ymy6m0">
        <OfferCard heading="Get the complete collection for just $27 USD" ctaLabel="Get Facial Aesthetics Clinical Roadmap™ now" note="One-time payment · $27 USD · Digital product" data-id="element-127" data-mp="2h3hnklqvqs4s" />
      </div>
    </Section>;
}